export class UserSetup {
  accountJwtToken: string;
}
